/**
 * Arsivora işareti ("Katman A"): çatı, güncel katman ve temel bir "A" kurar.
 * Mürekkep kutuda beyaz; ortadaki katman limondur. Uygulamada limon "şu an /
 * seçili" demektir, işarette de güncel sürümü taşır.
 *
 * Çizim docs/marka/uret.py ile aynıdır (64×64 ızgara). Logo dosyaları ve
 * kullanım kuralları: docs/marka/.
 */
export function BrandMark() {
  return (
    <span className="nx-nav-mark">
      <svg viewBox="0 0 64 64" aria-hidden="true" focusable="false" strokeWidth="0.8" strokeLinejoin="round">
        <g fill="currentColor" stroke="currentColor">
          <polygon points="26,8 38,8 47.17,30 35.17,30 32,22.4 28.83,30 16.83,30" />
          <polygon points="11,44 23,44 18,56 6,56" />
          <polygon points="41,44 53,44 58,56 46,56" />
        </g>
        <polygon className="nx-nav-mark__layer" points="15.58,33 48.42,33 51.75,41 12.25,41" />
      </svg>
    </span>
  )
}
